export const wincar = (
  <div className="">
    <p style={{fontSize:"1.7rem"}}>
      <strong>AUDI e-tron GT quattro 350kw</strong>
    </p>
 <ul>
 <li>• Istme/polstri värvus: must</li>
 <li>• Istmed: kaetud <i>microfiber Dinamica</i> kombineerituna kunstnahk polstriga (mono, pur 550), sh nahaga kaetud istmete peatoed ja käetugi</li>
 <li>• Välisvärv: Suzuka-hall metallikvärv</li>
 </ul>

 <strong>Lisavarustus:</strong>
 <ul>
 <li>• Alarmseade: lisaks <i>Comfort key</i> võimalustele lisanduvad salongi mahuandurid ja äravedamiskaitse läbi kallutusanduri</li>
 <li>• Assistentpakett <i>City</i>: sõiduraja vahetamise abisüsteem koos ristmikuassistendiga (ristisuunalise liikluse hoiatus)</li>
 <li>• Assistentpakett <i>Tour</i>: adaptiivne püsikiiruse hoidja ning liiklusmärkide kaamerapõhine tuvastussüsteem</li>
 <li>• Esilaternad <i>Matrix LED</i> tehnoloogiaga</li>
 <li>• Iluvõre: värvitud kerevärvi</li>
 <li>• Istmed: esiistmed sportistmed <i>Plus</i></li>
 <li>• Klaasid: tumendatud alates B-piilarist tahapoole (<i>Privacy Glass</i>)</li>
 <li>• Parkimisabi: kaamera auto tagaosas</li>
 <li>• Peeglid: välispeeglid elektriliselt kokkuklapitavad ja automaatselt tumenevad</li>
 <li>• Pikendatud tehasegarantii 5 aastat (2 aastat + 3 aastat lisagarantiid), läbisõiduni 100 000 km</li>
 <li>• Telefon ja kommunikatsioon: <i>Audi phone box Light</i>, universaalne telefonialus käetoe esiistmete vahel võimaldamaks telefonikõnesid läbi <i>Bluetooth</i> ühenduse</li>
 <li>• Valgustuspakett II: <i>Ambient lighting package Plus</i>, ambient ja kontuurvalgustus kogu autos (võimalik valida 30 värvitooni vahel)</li>
 <li>• Vedrustus <i>Adaptive air suspension</i> – elektrooniliselt seadistatav õhkvedrustus</li>
 <li>• Veljed: kergmetallveljed 9,5J/11,5J x 21“, 5-topeltkodaraga <i>Concave Module</i> disain, musta värvi, rehvidega 265/35 R21 // 305/30 R21</li>
 </ul>
 <strong>Audi Premium loovutuspakett</strong>
 <ul>
 <li>• Auto esmane loovutus Transpordiametis ja riigilõivud</li>
 <li>• Detailne autohooldus, auto süvahooldus, sh püsivahatamine</li>
 <li>• Lumehari ja parkimiskell</li>
 <li>• Audi Autoabi 24h ja Audi Mobiilsusgarantii</li>
 </ul>
  </div>
);
